import { render, staticRenderFns } from "./Stage.vue?vue&type=template&id=1a2170b0&lang=html&"
import script from "./Stage.vue?vue&type=script&lang=js&"
export * from "./Stage.vue?vue&type=script&lang=js&"
import style0 from "./Stage.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports